import { ButtonProps, SxProps, Theme } from "@mui/material";

export const textFieldStyles: SxProps<Theme> = (theme) => ({
  "& .MuiFormLabel-root": {
    color: theme.palette.panelInfo.calendar.lableColor,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.panelInfo.selector.borderColor,
  },
  "&:hover .MuiFormLabel-root": {
    color: theme.palette.panelInfo.calendar.lableColor,
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.panelInfo.selector.borderColor,
  },
  "& .MuiFormLabel-root.Mui-focused": {
    color: "#06B6D4",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
});

export const popperStyles: SxProps<Theme> = (theme) => ({
  "& .MuiPaper-root": {
    "--Paper-overlay": "none !important",
    backgroundColor: theme.palette.panelInfo.calendar.bg,
    borderRadius: 2,
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
  },
});

export const layoutStyles: SxProps = {
  "& .MuiPickersCalendarHeader-root": {
    borderRadius: 1,
    mb: 1,
  },
};

export const dayStyles: SxProps<Theme> = (theme) => ({
  borderRadius: "10px",
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.calendar.days.bgHover,
  },
  "&.Mui-selected": {
    backgroundColor: "#06B6D4 !important",
    color: "#fff !important",
  },
  "&.MuiPickersDay-today": {
    color: "#06B6D4",
    border: "none",
    backgroundColor: theme.palette.panelInfo.calendar.days.todayBG,
  },
});

export const yearButtonStyles: any = (theme: any) => ({
  "&.Mui-selected": {
    backgroundColor: "#06B6D4 !important",
    color: "#fff !important",
  },
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.calendar.days.bgHover,
  },
});

export const canlendarButtonStyles: SxProps<Theme> = (theme) => ({
  mt: 2,
  borderRadius: "9999px",
  backgroundColor: theme.palette.panelInfo.button.bg,
  borderColor: "#06B6D4",
  color: "#06B6D4",
  textTransform: "none",
  fontWeight: 500,
  px: 4,
  py: 1,
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.button.bgHover,
    borderColor: "#06B6D4",
  },
});
